module.exports = __webpack_public_path__ + "media/alert.33eb7f18.wav";